module.exports = __webpack_public_path__ + "img/1.a6cfecd8.jpg";